var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c("div", { staticClass: "c-accordion-panel", attrs: { id: _vm.id } }, [
        _c(
          "div",
          {
            staticClass: "c-accordion-panel__header",
            class: { "c-accordion-panel__header-active": _vm.isExpanded }
          },
          [
            _c(
              "h3",
              {
                staticClass: "c-accordion-panel__header-title",
                attrs: { id: _vm.titleId }
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _vm._v(" "),
            _vm.showEditLink
              ? _c(
                  "button",
                  {
                    staticClass: "c-accordion-panel__header-edit-selection",
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.setCurrentPanel(_vm.title)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.isMobile && _vm.editLabelMobile
                            ? _vm.editLabelMobile
                            : _vm.editLabel
                        ) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.isExpanded
          ? _c(
              "div",
              {
                staticClass: "c-accordion-panel__content",
                class: {
                  "c-accordion-panel__content--open js-active-accordion-panel":
                    _vm.isExpanded
                }
              },
              [_vm._t("default")],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ed1cb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ed1cb0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/contact-us/_vue/AccordionPanel.vue
// module id = 714
// module chunks = 0